import React, { useState } from 'react';
import { FaCircle } from 'react-icons/fa';

const Badge = ({ color }) => {
  return <FaCircle color={color} fontSize={8} />;
};

export default Badge;
